import { InMemoryCache } from "@apollo/client/cache";
import { ApolloClient, split } from "@apollo/client/core/index.js";
import { HttpLink } from "@apollo/client/link/http";
import { GraphQLWsLink } from "@apollo/client/link/subscriptions";
import { ApolloProvider } from "@apollo/client/react/context/ApolloProvider";
import { getMainDefinition } from "@apollo/client/utilities";
import { useRouteLoaderData } from "@remix-run/react";
import { createClient } from "graphql-ws";

import { type loader as rootLoader } from "~/root";

interface CreatorGraphQLProviderProps {
  children: React.ReactNode;
  graphqlUrl: string | undefined;
}

export function CreatorGraphQLProvider({
  children,
  graphqlUrl,
}: CreatorGraphQLProviderProps) {
  const rootLoaderData = useRouteLoaderData<typeof rootLoader>("root");
  const accessToken = rootLoaderData?.currentUser?.accessToken;

  if (!graphqlUrl) {
    console.warn("CreatorGraphQLProvider: graphqlUrl is missing.");
    return <>{children}</>;
  }

  const httpLink = new HttpLink({
    uri: graphqlUrl,
    headers: {
      Authorization: accessToken ? `${accessToken}` : "",
    },
  });

  const wsLink = new GraphQLWsLink(
    createClient({
      url: graphqlUrl.replace(/^http/, "ws"),
      connectionParams: () => {
        return {
          Authorization: accessToken ? `Bearer ${accessToken}` : "",
        };
      },
    }),
  );

  const splitLink = split(
    ({ query }) => {
      const definition = getMainDefinition(query);
      return (
        definition.kind === "OperationDefinition" &&
        definition.operation === "subscription"
      );
    },
    wsLink,
    httpLink,
  );

  const client = new ApolloClient({
    link: splitLink,
    cache: new InMemoryCache(),
  });

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
}
